module.exports = __webpack_public_path__ + "media/mypage/images/icons/s_icon_freeword-d9640671e074dd6aa7a64980302927a2.png";